import Vue from 'vue'
import App from './App.vue'

import 'bulma/css/bulma.css'
import 'vue-snotify/styles/material.css'
import '@pencilpix/vue2-clock-picker/dist/vue2-clock-picker.min.css'
import 'vuetify-daterange-picker/dist/vuetify-daterange-picker.css'
import 'buefy/dist/buefy.css'
import 'vue-date-pick/dist/vueDatePick.css'
import 'vue-loading-overlay/dist/vue-loading.css';

import moment from 'moment'
import Vue2Filters from 'vue2-filters'
import cors from 'cors'
import Snotify from 'vue-snotify'

import {  abilitiesPlugin } from '@casl/vue'
import ability from './ability'

import VDateRange from 'vuetify-daterange-picker'
import Buefy from 'buefy'
import VeeValidate from 'vee-validate'
import VueTables from 'vue-tables-2'
import VueCook from 'vue-cookies'
import VueCookie from 'vue-cookie'
import VModal from 'vue-js-modal'
import Autocomplete from 'v-autocomplete'

import Loading from 'vue-loading-overlay';

import AWS from 'aws-sdk';

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCoffee, faEye,
  faAddressCard,
  faHandPointer,
  faTrashAlt,
  faUserClock,
  faClock,
  faPlus,
  faPlusCircle,
  faFile,
  faCalendarAlt,
  faCheck,
  faUndo,
  faPencilAlt,
  faCheckCircle,
  faUsers,
  faCalendarCheck,
  faBriefcase,
  faMoneyCheckAlt, faLaptop, faProjectDiagram, faPlusSquare, faTimes, faBell, faArrowCircleLeft, faNewspaper, faCogs, faSignOutAlt, faExchangeAlt, faDownload } from '@fortawesome/free-solid-svg-icons'

library.add(
  faCoffee,
  faEye,
  faAddressCard,
  faHandPointer,
  faTrashAlt,
  faUserClock,
  faClock,
  faPlus,
  faPlusCircle,
  faFile,
  faCalendarAlt,
  faUndo,
  faCheck,
  faUsers,
  faCalendarCheck,
  faMoneyCheckAlt,
  faLaptop,
  faProjectDiagram,
  faPlusSquare,
  faTimes,
  faBell,
  faArrowCircleLeft,
  faNewspaper,
  faCogs,
  faSignOutAlt,
  faExchangeAlt,
  faPencilAlt,
  faCheckCircle,
  faBriefcase,
  faDownload)

Vue.config.productionTip = false

import router from './router.js'

router.beforeEach((to, from, next) => {
  // next('/servicios')

  // if(to.name==''){
  //   next('/servicios')
  // }else{
  //   next('/servicios')
  // }

  if( window.$cookies.get('RhSession') === null ){ //No tiene sesion
    if(to.name === 'servicios'){
      next()
    }else{
        next('/login')
    }
  }else{ //Si tiene sesion
    if(to.name === 'login'){
      next('/')
    }else{
      next()
    }
  }

})


Vue.use(moment)
Vue.use(Autocomplete)

Vue.use(Vue2Filters)
Vue.use(cors)
Vue.use(VeeValidate)
Vue.use(VDateRange)

Vue.use(Loading);
Vue.use(Buefy)
Vue.use(VueTables.ClientTable)
Vue.use(Snotify)
Vue.use(VueCook)
Vue.use(abilitiesPlugin, ability)
Vue.use(AWS)

Vue.use(VueCookie)
Vue.component('font-awesome-icon', FontAwesomeIcon)


Vue.use(VModal, {
  dialog: true
})


new Vue({
  render: h => h(App),
  router
}).$mount('#app')
